import { render, staticRenderFns } from "./BatchDeleteVD.vue?vue&type=template&id=fe10380e&scoped=true"
import script from "./BatchDeleteVD.vue?vue&type=script&lang=ts"
export * from "./BatchDeleteVD.vue?vue&type=script&lang=ts"
import style0 from "./BatchDeleteVD.vue?vue&type=style&index=0&id=fe10380e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe10380e",
  null
  
)

export default component.exports